import { AbstractRuleAlert, IRuleAlert } from "@comunicare/comunicare-interfaces";
import { TranslateService } from "@ngx-translate/core";

export class RuleAlert extends AbstractRuleAlert implements IRuleAlert {
  constructor(data: IRuleAlert, private translateService: TranslateService) {
    super(data);
  }

  protected translate(key: string): string {
    return this.translateService.instant(key);
  }
}
